import { Check, Loader2, X } from "lucide-react";
import type { ReactElement } from "react";
import { useSlugValidation } from "../../hooks/use-slug-validation";

export const SlugAvailabilityIndicator = ({
  slug,
  originalSlug,
}: {
  slug: string;
  originalSlug?: string;
}) => {
  const { isValidating, isAvailable, shouldShowIndicator, hasError } =
    useSlugValidation(slug, originalSlug);

  if (!shouldShowIndicator) {
    return null;
  }

  let icon: ReactElement | null = null;
  if (isValidating) {
    icon = (
      <Loader2
        aria-label="Checking..."
        className="size-4 animate-spin text-muted-foreground"
      />
    );
  } else if (hasError) {
    icon = <X aria-label="Error" className="size-4 text-destructive" />;
  } else if (isAvailable) {
    icon = <Check aria-label="Available" className="size-4 text-emerald-500" />;
  } else {
    icon = <X aria-label="Unavailable" className="size-4 text-destructive" />;
  }

  return (
    <span className="absolute inset-y-0 right-2 flex items-center">{icon}</span>
  );
};
